// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1hE_B","notes":"Notes_notes__1AH8U","note":"Notes_note__1g7-E","markdown":"Notes_markdown__1rrrm"};